import React, { Fragment, useEffect, useState } from "react";
import "../../../styles/common.css";
import { Outlet } from "react-router-dom";
import SideMenu from "./side-menu.jsx";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error.jsx';
import logo from '../../../assets/images/logo-round.jpeg'


const Layout = () => {
    const navigate = useNavigate();
    const [isMini, setIsMini] = useState(false);

    useEffect(() => {
        document.title = process.env.REACT_APP_NAME + ": Administrator";
        console.log(localStorage.getItem('@user_email'));
        console.log(localStorage.getItem('@user_role'));

        if (!(localStorage.getItem('@user_email') && localStorage.getItem('@user_role') && localStorage.getItem('@user_role') == 1)) {
            localStorage.removeItem("@name");
            localStorage.removeItem("@user_role");
            localStorage.removeItem("@user_email");
            navigate("/login");
        }


    }, []);
    const handleLogout = async () => {

        await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/logout", {
            email: localStorage.getItem('@user_email')
        },
            {
                withCredentials: true, // ✅ send cookies/session
            })
            .then(function (response) {
                if (response?.data?.status) {

                    localStorage.removeItem("@name");
                    localStorage.removeItem("@user_role");
                    localStorage.removeItem("@user_email");
                    navigate("/login");


                } else {


                    Swal.fire({ icon: "error", title: "Logout Failed", text: response?.data?.message });

                }
            })
            .catch(function (error) {

                catchError(error, navigate)
            });


    };


    return (
        <Fragment>



            <Outlet />






        </Fragment>
    );
};

export default Layout;
